function attributeIncludeParameters(type, attributeInclude) {
  if (!attributeInclude) {
    return [];
  }
  const parameterValues = [];
  if (attributeInclude === "all") {
    parameterValues.push(type);
  } else {
    if (attributeInclude.withKey) {
      parameterValues.push(
        `${type}:key(${attributeInclude.withKey.join("|")})`
      );
    }
    if (attributeInclude.ofType) {
      parameterValues.push(
        `${type}:type(${attributeInclude.ofType.join("|")})`
      );
    }
  }
  return parameterValues;
}
function prefixList(prefix) {
  return (list) => list.map((value) => `${prefix}${value}`);
}

function productWithQueryParameterValues(productWith) {
  const parameterValues = [];
  parameterValues.push(
    ...attributeIncludeParameters("attributes", productWith.attributes),
    ...attributeIncludeParameters(
      "advancedAttributes",
      productWith.advancedAttributes
    )
  );
  if (productWith.variants) {
    parameterValues.push("variants");
    if (productWith.variants && typeof productWith.variants === "object") {
      parameterValues.push(
        ...prefixList("variants.")(
          variantWithQueryParameterValues(productWith.variants)
        )
      );
    }
  }
  if (!productWith.images || productWith.images === "all") {
    parameterValues.push(`images.attributes:legacy(false)`);
  } else if (productWith.images.attributes) {
    const imagesAttributesFilters = [];
    imagesAttributesFilters.push("legacy(false)");
    if (productWith.images.attributes.withKey) {
      imagesAttributesFilters.push(
        `key(${productWith.images.attributes.withKey.join("|")})`
      );
    }
    if (imagesAttributesFilters.length > 0) {
      parameterValues.push(
        `images.attributes:${imagesAttributesFilters.join(":")}`
      );
    }
  }
  if (productWith.categories) {
    parameterValues.push("categories");
    if (typeof productWith.categories === "object") {
      if (productWith.categories.includeHidden) {
        parameterValues.push("categories:hidden(true)");
      }
      if (productWith.categories.countryLevelCustomData) {
        parameterValues.push("categories.countryLevelCustomData");
      }
      if (productWith.categories.shopLevelCustomData) {
        parameterValues.push("categories.shopLevelCustomData");
      }
      if (productWith.categories.properties === "all") ; else if (typeof productWith.categories.properties === "object") {
        parameterValues.push(
          `categories:properties(${productWith.categories.properties.withName.join("|")})`
        );
      } else {
        parameterValues.push(`categories:properties()`);
      }
    } else if (productWith.categories === "all") {
      parameterValues.push("categories:properties()");
    }
  }
  if (productWith.siblings) {
    parameterValues.push("siblings");
    if (productWith.siblings && typeof productWith.siblings === "object") {
      parameterValues.push(
        ...productWithQueryParameterValues(productWith.siblings).map(
          (queryParameter) => `siblings.${queryParameter}`
        )
      );
    }
  }
  if (productWith.priceRange === true) {
    parameterValues.push("priceRange");
  }
  if (productWith.reductionRange === true) {
    parameterValues.push("reductionRange");
  }
  if (productWith.baseCategories === true) {
    parameterValues.push("baseCategories");
  }
  if (productWith.lowestPriorPrice === true) {
    parameterValues.push("lowestPriorPrice");
  }
  if (productWith.searchCategoryIds === true) {
    parameterValues.push("searchCategoryIds");
  }
  return parameterValues;
}
function variantWithQueryParameterValues(variantWith) {
  return [
    ...attributeIncludeParameters("attributes", variantWith.attributes),
    ...attributeIncludeParameters(
      "advancedAttributes",
      variantWith.advancedAttributes
    ),
    ...variantWith.lowestPriorPrice ? ["lowestPriorPrice"] : [],
    ...variantWith.stock ? ["stock"] : [],
    ...variantWith.stock && typeof variantWith.stock === "object" && variantWith.stock.customData ? ["stock.customData"] : []
  ];
}

const encodeBase64 = (string) => {
  if (typeof Buffer === "function") {
    return Buffer.from(string).toString("base64");
  }
  const binString = Array.from(
    new TextEncoder().encode(string),
    (x) => String.fromCodePoint(x)
  ).join("");
  return btoa(binString);
};
const buildOrderCustomDataHeaders = (orderCustomData) => {
  if (!orderCustomData) {
    return {};
  }
  return {
    "X-Order-Custom-Data": encodeBase64(JSON.stringify(orderCustomData))
  };
};

function basketWithQueryParameter(basketWith) {
  const withParams = [];
  if (basketWith.items && basketWith.items.product) {
    withParams.push(
      ...productWithQueryParameterValues(basketWith.items.product).map(
        (value) => `items.product.${value}`
      )
    );
  }
  if (basketWith.items && basketWith.items.variant) {
    withParams.push(
      ...prefixList(`items.variant.`)(
        variantWithQueryParameterValues(basketWith.items.variant)
      )
    );
  }
  if (basketWith.items?.promotion === true) {
    withParams.push("items.promotion");
  }
  if (basketWith.applicablePromotions === true) {
    withParams.push("applicablePromotions");
  }
  return withParams;
}
function getBasketEndpointRequest(params) {
  return {
    method: "GET",
    endpoint: `/v1/baskets/${params.basketKey}`,
    headers: {
      ...buildOrderCustomDataHeaders(params.orderCustomData)
    },
    params: {
      ...params.with ? { with: basketWithQueryParameter(params.with).join(",") } : void 0,
      ...params.campaignKey ? { campaignKey: params.campaignKey } : void 0,
      ...params.checkoutShopId ? { checkoutShopId: params.checkoutShopId } : void 0,
      ...params.skipAvailabilityCheck ? { skipAvailabilityCheck: params.skipAvailabilityCheck } : void 0,
      ...params.includeItemsWithoutProductData ? {
        includeItemsWithoutProductData: params.includeItemsWithoutProductData
      } : void 0
    }
  };
}

function createBasketItemRequest(params) {
  const customData = params.pricePromotionKey ? { ...params.customData, pricePromotionKey: params.pricePromotionKey } : params.customData;
  return {
    method: "POST",
    endpoint: `/v1/baskets/${params.basketKey}/items`,
    successfulResponseCodes: [201, 206, 409, 412, 413],
    headers: {
      ...buildOrderCustomDataHeaders(params.orderCustomData)
    },
    params: {
      ...params.with ? { with: basketWithQueryParameter(params.with).join(",") } : void 0,
      ...params.campaignKey ? { campaignKey: params.campaignKey } : void 0,
      ...params.skipAvailabilityCheck ? { skipAvailabilityCheck: params.skipAvailabilityCheck } : void 0,
      ...params.includeItemsWithoutProductData ? {
        includeItemsWithoutProductData: params.includeItemsWithoutProductData
      } : void 0
    },
    data: {
      variantId: params.variantId,
      quantity: params.quantity,
      ...customData !== void 0 ? { customData } : void 0,
      ...params.childShopId ? { shopId: params.childShopId } : void 0,
      ...params.displayData ? { displayData: params.displayData } : void 0,
      ...params.itemGroup ? { itemGroup: params.itemGroup } : void 0,
      ...params.promotionId ? { promotionId: params.promotionId } : void 0
    }
  };
}

function deleteBasketItemRequest(params) {
  return {
    method: "DELETE",
    endpoint: `/v1/baskets/${params.basketKey}/items/${params.itemKey}`,
    headers: {
      ...buildOrderCustomDataHeaders(params.orderCustomData)
    },
    params: {
      ...params.with ? { with: basketWithQueryParameter(params.with).join(",") } : void 0,
      ...params.campaignKey ? { campaignKey: params.campaignKey } : void 0,
      ...params.skipAvailabilityCheck ? { skipAvailabilityCheck: params.skipAvailabilityCheck } : void 0,
      ...params.includeItemsWithoutProductData ? {
        includeItemsWithoutProductData: params.includeItemsWithoutProductData
      } : void 0
    }
  };
}

function updateBasketItemQuantityRequest(params) {
  const customData = params.pricePromotionKey ? { ...params.customData, pricePromotionKey: params.pricePromotionKey } : params.customData;
  return {
    method: "PATCH",
    endpoint: `/v1/baskets/${params.basketKey}/items/${params.itemKey}`,
    headers: {
      ...buildOrderCustomDataHeaders(params.orderCustomData)
    },
    params: {
      ...params.with ? { with: basketWithQueryParameter(params.with).join(",") } : void 0,
      ...params.campaignKey ? { campaignKey: params.campaignKey } : void 0,
      ...params.skipAvailabilityCheck ? { skipAvailabilityCheck: params.skipAvailabilityCheck } : void 0,
      ...params.includeItemsWithoutProductData ? {
        includeItemsWithoutProductData: params.includeItemsWithoutProductData
      } : void 0
    },
    data: {
      quantity: params.quantity,
      ...customData !== void 0 ? { customData } : void 0,
      ...params.displayData ? { displayData: params.displayData } : void 0,
      ...params.itemGroup ? { itemGroup: params.itemGroup } : void 0,
      ...params.promotionId !== void 0 ? { promotionId: params.promotionId } : void 0
    }
  };
}

function parametersForCategoryEndpoint(parameters) {
  return {
    ...categoryWithQueryParameters(parameters.with),
    ...parameters.includeHidden ? { showHidden: "true" } : void 0
  };
}
function categoryWithQueryParameters(categoryWith) {
  if (!categoryWith) {
    return {
      depth: 1,
      // include no properties by default
      with: "properties:name()"
    };
  }
  const withParams = [];
  if (categoryWith.parents) {
    withParams.push("parents");
  }
  if (categoryWith.properties) {
    if (categoryWith.properties === "all") {
      withParams.push("properties");
    } else {
      withParams.push(
        `properties:name(${categoryWith.properties.withName.join("|")})`
      );
    }
  } else {
    withParams.push("properties:name()");
  }
  if (categoryWith.children !== void 0 && categoryWith.children > 0) {
    withParams.push("descendants");
  }
  return {
    ...withParams.length > 0 ? { with: withParams.join(",") } : void 0,
    depth: (categoryWith.children ?? 0) + 1
  };
}

function createCategoriesEndpointRequest(params = {}) {
  return {
    method: "GET",
    endpoint: "/v1/categories",
    params: {
      ...parametersForCategoryEndpoint(params)
    }
  };
}

function createCategoriesByIdsEndpointRequest(parameters) {
  return {
    method: "GET",
    endpoint: "/v1/categories",
    params: {
      ids: parameters.categoryIds.join(","),
      ...parametersForCategoryEndpoint(parameters)
    }
  };
}

function createCategoryByIdEndpointRequest(params) {
  return {
    method: "GET",
    endpoint: `/v1/categories/${params.categoryId}`,
    params: {
      ...parametersForCategoryEndpoint(params)
    }
  };
}

function createCategoryBySlugEndpointRequest(params) {
  return {
    method: "GET",
    endpoint: `/v1/categories/${params.slugPath.join("/")}`,
    params: {
      ...parametersForCategoryEndpoint(params)
    }
  };
}

function queryParamsFromProductSearchQuery(productSearchQuery) {
  if (!productSearchQuery) {
    return void 0;
  }
  const filters = {
    "filters[category]": productSearchQuery.categoryId,
    ...(productSearchQuery.attributes || []).reduce((acc, attribute) => {
      switch (attribute.type) {
        case "attributes":
          acc[`filters[${attribute.key || attribute.id}]`] = attribute.values.join(`,`);
          break;
        case "attributes:not":
          acc[`filters:not[${attribute.key}]`] = attribute.values.join(`,`);
          break;
        case "boolean":
          acc[`filters[${attribute.key}]`] = attribute.value ? "true" : "false";
          break;
        default:
          console.error(`Unsupported filter type`, attribute);
      }
      return acc;
    }, {}),
    "filters[term]": productSearchQuery.term,
    "filters[minPrice]": productSearchQuery.minPrice,
    "filters[maxPrice]": productSearchQuery.maxPrice,
    "filters[minReduction]": productSearchQuery.minReduction,
    "filters[maxReduction]": productSearchQuery.maxReduction,
    "filters[hasCampaignReduction]": productSearchQuery.hasCampaignReduction === void 0 ? void 0 : productSearchQuery.hasCampaignReduction.toString(),
    containsSearch: productSearchQuery.containsSearch ? "true" : void 0,
    disableFuzziness: productSearchQuery.disableFuzziness ? "true" : void 0
  };
  const definedFilters = {};
  for (const [key, value] of Object.entries(filters)) {
    if (value !== void 0 && value !== null) {
      definedFilters[key] = value;
    }
  }
  return definedFilters;
}

var FilterTypes = /* @__PURE__ */ ((FilterTypes2) => {
  FilterTypes2["BOOLEAN"] = "boolean";
  FilterTypes2["ATTRIBUTES"] = "attributes";
  FilterTypes2["IDENTIFIER"] = "identifier";
  FilterTypes2["RANGE"] = "range";
  return FilterTypes2;
})(FilterTypes || {});
function createFiltersEndpointRequest(parameters) {
  const withParam = parameters.with ? parameters.with.join(",") : "values";
  return {
    method: "GET",
    endpoint: "/v1/filters",
    params: {
      ...withParam ? { with: withParam } : void 0,
      ...parameters.including ? { including: parameters.including.join(",") } : void 0,
      ...parameters.campaignKey ? { campaignKey: parameters.campaignKey } : void 0,
      ...parameters.includeSoldOut ? { includeSoldOut: parameters.includeSoldOut } : void 0,
      ...parameters.includeSellableForFree ? { includeSellableForFree: parameters.includeSellableForFree } : void 0,
      ...queryParamsFromProductSearchQuery(parameters.where),
      ...parameters.orFiltersOperator && parameters.orFiltersOperator.length > 1 ? { orFiltersOperator: parameters.orFiltersOperator.join(",") } : void 0
    }
  };
}

function createProductByIdEndpointRequest(parameters) {
  return {
    method: "GET",
    endpoint: `/v1/products/${parameters.productId}`,
    params: {
      ...parameters.with ? { with: productWithQueryParameterValues(parameters.with).join(`,`) } : void 0,
      ...parameters.campaignKey ? { campaignKey: parameters.campaignKey } : void 0,
      ...parameters.pricePromotionKey ? {
        pricePromotionKey: parameters.pricePromotionKey
      } : void 0,
      ...parameters.includeSellableForFree ? { includeSellableForFree: parameters.includeSellableForFree } : void 0
    }
  };
}

function createProductsSearchEndpointRequest(parameters) {
  return {
    method: "GET",
    endpoint: "/v1/products",
    params: {
      ...parameters.with ? { with: productWithQueryParameterValues(parameters.with).join(`,`) } : void 0,
      ...queryParamsFromProductSearchQuery(parameters.where),
      ...parameters.pricePromotionKey ? {
        pricePromotionKey: parameters.pricePromotionKey
      } : void 0,
      ...parameters.sort && parameters.sort.by ? { sort: parameters.sort.by } : void 0,
      ...parameters.sort && parameters.sort.direction ? { sortDir: parameters.sort.direction } : void 0,
      ...parameters.sort && parameters.sort.score ? { sortScore: parameters.sort.score } : void 0,
      ...parameters.sort && parameters.sort.channel ? { sortChannel: parameters.sort.channel } : void 0,
      ...parameters.sort && parameters.sort.sortingKey ? {
        sortingKey: Array.isArray(parameters.sort.sortingKey) ? parameters.sort.sortingKey.join(",") : parameters.sort.sortingKey
      } : void 0,
      ...parameters.pagination && parameters.pagination.page ? { page: parameters.pagination.page } : void 0,
      ...parameters.pagination && parameters.pagination.perPage ? { perPage: parameters.pagination.perPage } : void 0,
      ...parameters.campaignKey ? { campaignKey: parameters.campaignKey } : void 0,
      ...parameters.includeSellableForFree ? { includeSellableForFree: parameters.includeSellableForFree } : void 0,
      ...parameters.includeSoldOut ? { includeSoldOut: parameters.includeSoldOut } : void 0,
      ...parameters.minProductId ? { minProductId: parameters.minProductId } : void 0,
      ...parameters.orFiltersOperator && parameters.orFiltersOperator.length > 1 ? { orFiltersOperator: parameters.orFiltersOperator.join(",") } : void 0,
      ...parameters.trackSearchAnalyticsEvent && { trackSearchAnalyticsEvent: "true" }
    }
  };
}

function createGetRedirectsEndpointRequest(parameters) {
  return {
    method: "GET",
    endpoint: `/v1/redirects`,
    params: {
      ...parameters.pagination && parameters.pagination.page ? { page: parameters.pagination.page } : void 0,
      ...parameters.pagination && parameters.pagination.perPage ? { perPage: parameters.pagination.perPage } : void 0
    }
  };
}
function createPostRedirectEndpointRequest(url) {
  return {
    method: "POST",
    endpoint: "/v1/redirects",
    data: {
      url
    }
  };
}

function createProductsByIdsEndpointRequest(parameters) {
  if (parameters.productIds.length === 0) {
    throw new Error(`"productIds" parameter must not be an empty array.`);
  }
  return {
    method: "GET",
    endpoint: `/v1/products`,
    params: {
      ids: parameters.productIds.join(`,`),
      ...parameters.with ? { with: productWithQueryParameterValues(parameters.with).join(`,`) } : void 0,
      ...parameters.campaignKey ? { campaignKey: parameters.campaignKey } : void 0,
      ...parameters.pricePromotionKey ? {
        pricePromotionKey: parameters.pricePromotionKey
      } : void 0,
      ...parameters.includeSellableForFree ? { includeSellableForFree: parameters.includeSellableForFree } : void 0
    }
  };
}

function wishlistWithQueryParameter(wishlistWith) {
  const withParams = [];
  if (wishlistWith.items && wishlistWith.items.product) {
    withParams.push(
      ...productWithQueryParameterValues(wishlistWith.items.product).map(
        (value) => `items.product.${value}`
      )
    );
  }
  if (wishlistWith.items && wishlistWith.items.variant) {
    withParams.push(
      ...variantWithQueryParameterValues(wishlistWith.items.variant).map(
        (value) => `items.variant.${value}`
      )
    );
  }
  return withParams;
}

var AddToWishlistFailureKind = /* @__PURE__ */ ((AddToWishlistFailureKind2) => {
  AddToWishlistFailureKind2["ItemUnavailable"] = "ItemUnavailable";
  AddToWishlistFailureKind2["MaximumItemCountReached"] = "MaximumItemCountReached";
  AddToWishlistFailureKind2["ItemAlreadyPresent"] = "ItemAlreadyPresent";
  AddToWishlistFailureKind2["Unknown"] = "Unknown";
  return AddToWishlistFailureKind2;
})(AddToWishlistFailureKind || {});
function addWishlistItemEndpointRequest(params) {
  return {
    method: "POST",
    endpoint: `/v1/wishlists/${params.wishlistKey}/items`,
    successfulResponseCodes: [201, 409, 412, 413],
    params: {
      ...params.with ? {
        with: wishlistWithQueryParameter(params.with).join(",")
      } : void 0,
      ...params.campaignKey ? { campaignKey: params.campaignKey } : void 0,
      ...params.pricePromotionKey ? { pricePromotionKey: params.pricePromotionKey } : void 0
    },
    data: {
      ...params.item,
      ...params.itemGroup ? { itemGroup: params.itemGroup } : void 0,
      ...params.customData ? { customData: params.customData } : void 0
    }
  };
}
function addToWishlistFailureKindFromStatusCode(statusCode) {
  switch (statusCode) {
    case 409:
      return "ItemAlreadyPresent" /* ItemAlreadyPresent */;
    case 412:
      return "ItemUnavailable" /* ItemUnavailable */;
    case 413:
      return "MaximumItemCountReached" /* MaximumItemCountReached */;
    default:
      return "Unknown" /* Unknown */;
  }
}

function deleteWishlistEndpointRequest(params) {
  return {
    method: "DELETE",
    endpoint: `/v1/wishlists/${params.wishlistKey}/items/${params.itemKey}`,
    params: {
      ...params.with ? { with: wishlistWithQueryParameter(params.with).join(",") } : void 0,
      ...params.campaignKey ? { campaignKey: params.campaignKey } : void 0,
      ...params.pricePromotionKey ? { pricePromotionKey: params.pricePromotionKey } : void 0
    }
  };
}

function getWishlistEndpointRequest(params) {
  return {
    method: "GET",
    endpoint: `/v1/wishlists/${params.wishlistKey}`,
    params: {
      ...params.with ? { with: wishlistWithQueryParameter(params.with).join(",") } : void 0,
      ...params.campaignKey ? { campaignKey: params.campaignKey } : void 0,
      ...params.pricePromotionKey ? { pricePromotionKey: params.pricePromotionKey } : void 0
    }
  };
}

var __defProp$1 = Object.defineProperty;
var __defNormalProp$1 = (obj, key, value) => key in obj ? __defProp$1(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField$1 = (obj, key, value) => {
  __defNormalProp$1(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class FetchError extends Error {
  constructor(response) {
    const message = `Failed to fetch ${response.url}. ${response.status} ${response.statusText}`;
    super(message);
    __publicField$1(this, "response");
    this.response = response;
    this.name = "FetchError";
    this.message = message;
  }
}

const getParamsString = (params) => {
  let query = "";
  for (const [key, value] of Object.entries(params)) {
    if (!value) {
      continue;
    }
    if (query.length > 0) {
      query += "&";
    }
    query += `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
  }
  if (query) {
    return `?${query}`;
  }
  return "";
};
async function execute(host, shopId, bapiCall, auth, additionalHeaders) {
  const url = `https://${host}${bapiCall.endpoint}${getParamsString({
    ...bapiCall.params,
    shopId
  })}`;
  const response = await fetch(url, {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      ...typeof window === "undefined" ? { "accept-encoding": "gzip, deflate" } : void 0,
      ...auth && auth.type === "token" ? { "X-Access-Token": auth.token } : {},
      ...additionalHeaders,
      ...bapiCall.headers
    },
    method: bapiCall.method,
    body: bapiCall.method === "POST" || bapiCall.method === "PATCH" ? JSON.stringify(bapiCall.data) : void 0
  });
  if (bapiCall.successfulResponseCodes) {
    if (!bapiCall.successfulResponseCodes.includes(response.status)) {
      throw new FetchError(response);
    }
  } else if (!response.ok) {
    throw new FetchError(response);
  }
  const data = await response.json();
  return {
    data,
    statusCode: response.status
  };
}

function suggetionsWithQueryParameter(suggestionsWith) {
  const withParams = [];
  if (suggestionsWith.products && typeof suggestionsWith.products === "object") {
    withParams.push(
      ...productWithQueryParameterValues(suggestionsWith.products).map(
        (value) => `products.${value}`
      )
    );
  }
  return withParams;
}
function createSearchSuggestionsEndpointRequest(parameters) {
  const topLevelIncludes = [];
  if (parameters.with) {
    if (parameters.with.brands) {
      topLevelIncludes.push("brands");
    }
    if (parameters.with.categories) {
      topLevelIncludes.push("categories");
    }
    if (parameters.with.productNames) {
      topLevelIncludes.push("productNames");
    }
    if (parameters.with.products) {
      topLevelIncludes.push("products");
    }
  }
  return {
    method: "GET",
    endpoint: `/v1/search/suggestions`,
    params: {
      term: parameters.term,
      ...parameters.campaignKey ? { campaignKey: parameters.campaignKey } : void 0,
      with: [
        topLevelIncludes,
        ...parameters.with ? suggetionsWithQueryParameter(parameters.with) : []
      ].join(`,`)
    }
  };
}

function createrSearchMappingsEndpointRequest(parameters) {
  return {
    method: "GET",
    endpoint: `/v1/search/mappings`,
    params: {
      term: parameters.term
    }
  };
}

function createVariantsByIdsEndpointRequest(parameters) {
  if (parameters.variantIds.length === 0) {
    throw new Error(`"variantIds" parameter must not be an empty array.`);
  }
  return {
    method: "GET",
    endpoint: `/v1/variants`,
    params: {
      ids: parameters.variantIds.join(`,`),
      ...parameters.with ? { with: variantWithQueryParameterValues(parameters.with).join(`,`) } : void 0,
      ...parameters.campaignKey ? { campaignKey: parameters.campaignKey } : void 0,
      ...parameters.pricePromotionKey ? {
        pricePromotionKey: parameters.pricePromotionKey
      } : void 0
    }
  };
}

function createFilterValuesEndpointRequest(parameters) {
  return {
    method: "GET",
    endpoint: `/v1/filters/${parameters.groupName}/values`,
    params: {
      ...queryParamsFromProductSearchQuery(parameters.where),
      ...parameters.campaignKey ? { campaignKey: parameters.campaignKey } : void 0,
      ...parameters.orFiltersOperator && parameters.orFiltersOperator.length > 1 ? { orFiltersOperator: parameters.orFiltersOperator.join(",") } : void 0
    }
  };
}

function createTypeaheadSuggestionsEndpointRequest(parameters) {
  return {
    method: "POST",
    endpoint: `/v1/typeahead`,
    params: {
      term: parameters.term,
      // ...(parameters.campaignKey
      //   ? {campaignKey: parameters.campaignKey}
      //   : undefined),
      with: [
        ...parameters.with?.products ? prefixList("product.")(
          productWithQueryParameterValues(parameters.with?.products)
        ) : [],
        ...parameters.with?.categories?.parents === "all" ? ["category.parents"] : [],
        ...parameters.with?.categories?.children ? ["category.children"] : []
      ].join(`,`),
      ...parameters.with?.categories?.children ? { categoryDepth: parameters.with?.categories?.children + 1 } : void 0
    },
    data: {
      ...parameters.categoryId ? { categoryId: parameters.categoryId } : void 0,
      ...parameters.productLimit != null ? { limit: parameters.productLimit } : void 0
    }
  };
}

function createAttributeByKeyEndpointRequest(key) {
  return {
    method: "GET",
    endpoint: `/v1/attributes/${key}`
  };
}

function createProductByReferenceKeyRequest(parameters) {
  if (!parameters.referenceKey) {
    throw new Error(`"referenceKey" must not be an empty string.`);
  }
  return {
    method: "GET",
    endpoint: `/v1/products`,
    params: {
      referenceKey: parameters.referenceKey,
      ...parameters.with ? { with: productWithQueryParameterValues(parameters.with).join(`,`) } : void 0,
      ...parameters.campaignKey ? { campaignKey: parameters.campaignKey } : void 0,
      ...parameters.pricePromotionKey ? {
        pricePromotionKey: parameters.pricePromotionKey
      } : void 0,
      ...parameters.includeSellableForFree ? { includeSellableForFree: parameters.includeSellableForFree } : void 0
    }
  };
}

function createSearchResolveEndpointRequest(parameters) {
  return {
    method: "GET",
    endpoint: `/v1/search/resolve`,
    params: {
      term: parameters.term,
      ...parameters.categoryId ? { categoryId: parameters.categoryId } : void 0
    }
  };
}

function createBrandsEndpointRequest(parameters = {}) {
  return {
    method: "GET",
    endpoint: "/v1/brands",
    params: {
      ...parameters.pagination && parameters.pagination.page ? { page: parameters.pagination.page } : void 0,
      ...parameters.pagination && parameters.pagination.perPage ? { perPage: parameters.pagination.perPage } : void 0
    }
  };
}

function createBrandByIdEndpointRequest(brandId) {
  return {
    method: "GET",
    endpoint: `/v1/brands/${brandId}`
  };
}

function createCampaignByIdEndpointRequest(campaignId) {
  return {
    method: "GET",
    endpoint: `/v1/campaigns/${campaignId}`
  };
}

function createCampaignsEndpointRequest(parameters = {}) {
  return {
    method: "GET",
    endpoint: "/v1/campaigns",
    params: {
      ...parameters.sort && parameters.sort.by ? { sort: parameters.sort.by } : void 0,
      ...parameters.sort && parameters.sort.direction ? { sortDir: parameters.sort.direction } : void 0,
      ...parameters.pagination && parameters.pagination.page ? { page: parameters.pagination.page } : void 0,
      ...parameters.pagination && parameters.pagination.perPage ? { perPage: parameters.pagination.perPage } : void 0
    }
  };
}

function createNavigationByIdEndpointRequest(navigationTreeId, parameters) {
  return {
    method: "GET",
    endpoint: `/v1/navigation/trees/${navigationTreeId}`,
    params: {
      ...parameters.locale ? { locale: parameters.locale } : {},
      ...parameters?.with?.category ? { with: "category" } : {}
    }
  };
}

function createNavigationAllEndpointRequest(parameters) {
  return {
    method: "GET",
    endpoint: "/v1/navigation/trees",
    params: {
      ...parameters.locale ? { locale: parameters.locale } : {},
      ...parameters?.with?.category ? { with: "category" } : {}
    }
  };
}

function createPromotionsEndpointRequest(parameters = {}) {
  return {
    method: "GET",
    endpoint: "/v1/promotions",
    params: {
      ...parameters.pagination && parameters.pagination.page ? { page: parameters.pagination.page } : void 0,
      ...parameters.pagination && parameters.pagination.perPage ? { perPage: parameters.pagination.perPage } : void 0,
      ...parameters.ids ? { ids: parameters.ids.join(",") } : void 0,
      ...parameters.activeAt ? { activeAt: parameters.activeAt } : void 0
    }
  };
}

const searchV2WithParamsToQuery = (includes) => {
  const params = [];
  let depth = 0;
  if (includes?.categories) {
    if (includes.categories.parents === "all") {
      params.push("category.parents");
    }
    if (includes.categories.children) {
      depth = includes.categories.children + 1;
      params.push("category.children");
    }
    if (includes.categories.properties) {
      params.push(
        includes.categories.properties.map(
          (propertyName) => `category.properties:name(${propertyName})`
        )
      );
    }
  }
  if (includes?.product) {
    params.push(
      prefixList("product.")(productWithQueryParameterValues(includes.product))
    );
  }
  if (includes?.navigationItem) {
    if (includes.navigationItem.category === "all") {
      params.push("navigationItem.category");
    } else if (includes.navigationItem.category?.properties) {
      params.push(
        includes.navigationItem.category.properties.map(
          (propertyName) => `navigationItem.category.properties:name(${propertyName})`
        )
      );
    }
  }
  if (params.length === 0) {
    return {};
  }
  return {
    with: params.join(","),
    "category.depth": depth
  };
};

function createSearchV2SuggestionsEndpointRequest(parameters) {
  return {
    method: "GET",
    endpoint: `/v2/search/suggestions`,
    params: {
      term: parameters.term,
      ...parameters.categoryId ? { campaignKey: parameters.categoryId } : void 0,
      ...searchV2WithParamsToQuery(parameters.with)
    }
  };
}

function createSearchV2ResolveEndpointRequest(parameters) {
  return {
    method: "GET",
    endpoint: `/v2/search/resolve`,
    successfulResponseCodes: [200],
    params: {
      term: parameters.term,
      ...parameters.categoryId ? { categoryId: parameters.categoryId } : void 0,
      ...searchV2WithParamsToQuery(parameters.with)
    }
  };
}

const parseHost = (host) => {
  if (host.startsWith("https://")) {
    return new URL(host).host;
  }
  return host;
};

var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
var ExistingItemHandling = /* @__PURE__ */ ((ExistingItemHandling2) => {
  ExistingItemHandling2[ExistingItemHandling2["KeepExisting"] = 0] = "KeepExisting";
  ExistingItemHandling2[ExistingItemHandling2["AddQuantityToExisting"] = 1] = "AddQuantityToExisting";
  ExistingItemHandling2[ExistingItemHandling2["ReplaceExisting"] = 2] = "ReplaceExisting";
  ExistingItemHandling2[ExistingItemHandling2["ReplaceExistingWithCombinedQuantity"] = 3] = "ReplaceExistingWithCombinedQuantity";
  return ExistingItemHandling2;
})(ExistingItemHandling || {});
var AddToBasketFailureKind = /* @__PURE__ */ ((AddToBasketFailureKind2) => {
  AddToBasketFailureKind2["VariantAlreadyPresent"] = "VariantAlreadyPresent";
  AddToBasketFailureKind2["ItemUnvailable"] = "ItemUnvailable";
  AddToBasketFailureKind2["MaximumItemCountReached"] = "MaximumItemCountReached";
  AddToBasketFailureKind2["ItemDataNotFound"] = "ItemDataNotFound";
  AddToBasketFailureKind2["ItemAddedWithReducedQuantity"] = "ItemAddedWithReducedQuantity";
  AddToBasketFailureKind2["Unknown"] = "Unknown";
  return AddToBasketFailureKind2;
})(AddToBasketFailureKind || {});
function addToBasketFailureKindFromStatusCode(statusCode) {
  switch (statusCode) {
    case 409:
      return "VariantAlreadyPresent" /* VariantAlreadyPresent */;
    case 412:
      return "ItemUnvailable" /* ItemUnvailable */;
    case 413:
      return "MaximumItemCountReached" /* MaximumItemCountReached */;
    case 424:
      return "ItemDataNotFound" /* ItemDataNotFound */;
    case 206:
      return "ItemAddedWithReducedQuantity" /* ItemAddedWithReducedQuantity */;
    default:
      return "Unknown" /* Unknown */;
  }
}
function updateBasketItemFailureKindFromStatusCode(statusCode) {
  switch (statusCode) {
    case 206:
      return "ItemAddedWithReducedQuantity" /* ItemAddedWithReducedQuantity */;
    case 404:
      return "BasketItemNotFound" /* BasketItemNotFound */;
    case 412:
      return "ItemUnvailable" /* ItemUnvailable */;
    default:
      return "Unknown" /* Unknown */;
  }
}
const findBasketItem = (basket, itemToAdd) => {
  return basket.items.find((item) => {
    if (item.variant.id !== itemToAdd.variantId) {
      return false;
    }
    return item.itemGroup?.id === itemToAdd.itemGroupId;
  });
};
class StorefrontAPIClient {
  constructor(config) {
    __publicField(this, "host");
    __publicField(this, "shopId");
    __publicField(this, "auth");
    __publicField(this, "additionalHeaders");
    __publicField(this, "attributes", {
      getByKey: (key) => this.execute(createAttributeByKeyEndpointRequest(key))
    });
    __publicField(this, "basket", {
      get: async (basketKey, params = {}) => {
        const response = await this.execute(
          getBasketEndpointRequest({
            ...params,
            basketKey
          })
        );
        return {
          type: "success",
          statusCode: 200,
          basket: response
        };
      },
      addItem: async (basketKey, variantId, quantity = 1, params = {}) => {
        const response = await this.executeWithStatus(
          createBasketItemRequest({
            ...params,
            basketKey,
            variantId,
            quantity
          })
        );
        if (response.statusCode === 200 || response.statusCode === 201) {
          return {
            type: "success",
            statusCode: response.statusCode,
            basket: response.data
          };
        } else {
          return {
            type: "failure",
            statusCode: response.statusCode,
            kind: addToBasketFailureKindFromStatusCode(response.statusCode),
            basket: response.data
          };
        }
      },
      /**
       * Adds or updates many variants in the basket
       *
       * If an item with the same variant ID already exists the strategy defined in
       * `options.existingItemHandling` will be used to resolve the conflict.
       * See `ExistingItemHandling` for more details on the individual approaches.
       *
       * If a quantity of 0 is provided, that'll delete any existing basket item for the same variant unless "keep existing" is set.
       *
       * This method throws if the initial basket GET fails.
       *
       * If the caller specifies any of `customData`, `displayData`, or `pricePromotionKey` this will update the _entire_ `customData` for that specific basket item.
       * There is one notable exception: If `ExistingItemHandling.AddQuantityToExisting` is specified, the previous display data will be preserved.
       */
      addOrUpdateItems: async (basketKey, items, basketParams = {}, options = {
        existingItemHandling: 3 /* ReplaceExistingWithCombinedQuantity */
      }) => {
        const initialBasketResponse = await this.basket.get(
          basketKey,
          basketParams
        );
        if (initialBasketResponse.type !== "success") {
          throw Error("Failed to get initial basket");
        }
        const client = new BasketMultiOperationsClient(
          this,
          initialBasketResponse.basket
        );
        for (const itemToAdd of items) {
          const existingBasketItem = findBasketItem(client.latestBasket, {
            variantId: itemToAdd.variantId,
            itemGroupId: itemToAdd.params?.itemGroup?.id
          });
          const { variantId, quantity = 1 } = itemToAdd;
          const params = {
            ...basketParams,
            ...itemToAdd.params
          };
          if (existingBasketItem) {
            if (quantity === 0) {
              switch (options.existingItemHandling) {
                case 0 /* KeepExisting */:
                case 1 /* AddQuantityToExisting */:
                  continue;
                case 2 /* ReplaceExisting */:
                  await client.deleteItem(
                    existingBasketItem.key,
                    params,
                    variantId
                  );
                  break;
                case 3 /* ReplaceExistingWithCombinedQuantity */:
                  await client.deleteItem(
                    existingBasketItem.key,
                    params,
                    variantId
                  );
                  await client.addItem(
                    variantId,
                    existingBasketItem.quantity,
                    params
                  );
                  break;
              }
            } else {
              switch (options.existingItemHandling) {
                case 0 /* KeepExisting */:
                  continue;
                case 1 /* AddQuantityToExisting */:
                  await client.updateItem(
                    existingBasketItem.key,
                    existingBasketItem.quantity + quantity,
                    params,
                    variantId
                  );
                  continue;
                case 2 /* ReplaceExisting */:
                  await client.deleteItem(
                    existingBasketItem.key,
                    params,
                    variantId
                  );
                  await client.addItem(variantId, quantity, params);
                  break;
                case 3 /* ReplaceExistingWithCombinedQuantity */:
                  await client.deleteItem(
                    existingBasketItem.key,
                    params,
                    variantId
                  );
                  await client.addItem(
                    variantId,
                    quantity + existingBasketItem.quantity,
                    params
                  );
                  break;
              }
            }
          } else if (quantity > 0) {
            await client.addItem(variantId, quantity, params);
          }
        }
        const errors = client.errors;
        const latestBasket = client.latestBasket;
        if (errors.length) {
          return {
            type: "failure",
            basket: latestBasket,
            errors
          };
        }
        return {
          type: "success",
          basket: latestBasket
        };
      },
      updateItem: async (basketKey, itemKey, quantity, params = {}) => {
        const response = await this.executeWithStatus(
          updateBasketItemQuantityRequest({
            ...params,
            basketKey,
            itemKey,
            quantity
          })
        );
        if (response.statusCode === 200) {
          return {
            type: "success",
            statusCode: response.statusCode,
            basket: response.data
          };
        } else {
          return {
            type: "failure",
            statusCode: response.statusCode,
            basket: response.data,
            kind: updateBasketItemFailureKindFromStatusCode(response.statusCode)
          };
        }
      },
      deleteItem: (basketKey, itemKey, params = {}) => this.execute(
        deleteBasketItemRequest({
          ...params,
          basketKey,
          itemKey
        })
      )
    });
    __publicField(this, "categories", {
      getById: (categoryId, parameters = {}) => {
        return this.execute(
          createCategoryByIdEndpointRequest({
            ...parameters,
            categoryId
          })
        );
      },
      getByIds: (categoryIds, parameters = {}) => {
        return this.execute(
          createCategoriesByIdsEndpointRequest({
            ...parameters,
            categoryIds
          })
        );
      },
      getByPath: (path, parameters = {}) => {
        return this.execute(
          createCategoryBySlugEndpointRequest({
            ...parameters,
            slugPath: path
          })
        );
      },
      getRoots: (parameters = {}) => {
        return this.execute(createCategoriesEndpointRequest(parameters));
      }
    });
    __publicField(this, "filters", {
      get: (params) => this.execute(createFiltersEndpointRequest(params)),
      getValues: (groupName, params) => this.execute(
        createFilterValuesEndpointRequest({
          groupName,
          ...params
        })
      )
    });
    __publicField(this, "redirects", {
      get: (params = {}) => this.execute(createGetRedirectsEndpointRequest(params)),
      post: async (url) => {
        try {
          return await this.execute(createPostRedirectEndpointRequest(url));
        } catch (e) {
          if (e instanceof FetchError && e.response.status === 404) {
            return void 0;
          }
          throw e;
        }
      }
    });
    __publicField(this, "products", {
      getById: (productId, params = {}) => this.execute(createProductByIdEndpointRequest({ ...params, productId })),
      getByIds: async (productIds, params = {}) => {
        if (productIds.length === 0) {
          return [];
        }
        const response = await this.execute(
          createProductsByIdsEndpointRequest({ ...params, productIds })
        );
        return response.entities;
      },
      getByReferenceKeys: async (referenceKeys, params = {}) => {
        const paramsWithReferenceKeys = {
          ...params,
          where: {
            attributes: [
              {
                type: "attributes",
                key: "referenceKey",
                values: referenceKeys
              }
            ]
          }
        };
        const response = await this.execute(
          createProductsSearchEndpointRequest(paramsWithReferenceKeys)
        );
        return response.entities;
      },
      getByReferenceKey: async (referenceKey, params = {}) => {
        const response = await this.execute(
          createProductByReferenceKeyRequest({ ...params, referenceKey })
        );
        if (response.entities.length === 1) {
          return response.entities[0];
        } else if (response.entities.length > 1) {
          throw new Error(
            `Got ${response.entities.length} products for a single referenceKey`
          );
        }
        return null;
      },
      query: (params = {}) => this.execute(createProductsSearchEndpointRequest(params))
    });
    __publicField(this, "wishlist", {
      get: (wishlistKey, params = {}) => this.execute(
        getWishlistEndpointRequest({
          ...params,
          wishlistKey
        })
      ),
      addItem: async (wishlistKey, item, params = {}) => {
        const response = await this.executeWithStatus(
          addWishlistItemEndpointRequest({
            ...params,
            wishlistKey,
            item
          })
        );
        if (response.statusCode === 201) {
          return {
            type: "success",
            statusCode: response.statusCode,
            wishlist: response.data
          };
        } else {
          return {
            type: "failure",
            statusCode: response.statusCode,
            kind: addToWishlistFailureKindFromStatusCode(response.statusCode),
            wishlist: response.data
          };
        }
      },
      deleteItem: (wishlistKey, itemKey, params = {}) => this.execute(
        deleteWishlistEndpointRequest({
          ...params,
          wishlistKey,
          itemKey
        })
      )
    });
    __publicField(this, "search", {
      suggestions: (term, params = {}) => {
        return this.execute(
          createSearchSuggestionsEndpointRequest({ ...params, term })
        );
      },
      mappings: (term) => {
        return this.execute(createrSearchMappingsEndpointRequest({ term }));
      },
      resolve: (term, params = {}) => {
        return this.execute(
          createSearchResolveEndpointRequest({ term, ...params })
        );
      }
    });
    __publicField(this, "searchv2", {
      suggestions: (term, params = {}) => {
        return this.execute(
          createSearchV2SuggestionsEndpointRequest({ ...params, term })
        );
      },
      resolve: async (term, params = {}) => {
        try {
          return await this.execute(
            createSearchV2ResolveEndpointRequest({ term, ...params })
          );
        } catch (error) {
          if (error instanceof FetchError && error.response.status === 204) {
            return void 0;
          }
          throw error;
        }
      }
    });
    __publicField(this, "typeahead", {
      suggestions: (term, params = {}) => {
        return this.execute(
          createTypeaheadSuggestionsEndpointRequest({ ...params, term })
        );
      }
    });
    __publicField(this, "variants", {
      getByIds: async (variantIds, params = {}) => {
        if (variantIds.length === 0) {
          return [];
        }
        const response = await this.execute(
          createVariantsByIdsEndpointRequest({ ...params, variantIds })
        );
        return response.entities;
      }
    });
    __publicField(this, "shopConfiguration", {
      get: () => {
        return this.execute({
          method: "GET",
          endpoint: "/v1/shop-configuration"
        });
      }
    });
    __publicField(this, "brands", {
      getById: (brandId) => {
        return this.execute(createBrandByIdEndpointRequest(brandId));
      },
      get: (parameters) => {
        return this.execute(createBrandsEndpointRequest(parameters));
      }
    });
    __publicField(this, "campaigns", {
      getById: (campaignId) => {
        return this.execute(createCampaignByIdEndpointRequest(campaignId));
      },
      get: (parameters = {}) => {
        return this.execute(createCampaignsEndpointRequest(parameters));
      }
    });
    __publicField(this, "navigation", {
      getById: (navigationTreeId, parameters = {}) => {
        return this.execute(
          createNavigationByIdEndpointRequest(navigationTreeId, parameters)
        );
      },
      getAll: (parameters = {}) => {
        return this.execute(createNavigationAllEndpointRequest(parameters));
      }
    });
    __publicField(this, "promotions", {
      get: (params = {}) => this.execute(createPromotionsEndpointRequest(params)),
      getByIds: (ids) => {
        return this.execute(
          createPromotionsEndpointRequest({
            ids
          })
        );
      }
    });
    this.host = parseHost(config.host);
    this.shopId = config.shopId;
    this.auth = config.auth;
    this.additionalHeaders = config.additionalHeaders;
  }
  async execute(request) {
    const response = await execute(
      this.host,
      this.shopId,
      request,
      this.auth,
      this.additionalHeaders
    );
    return response.data;
  }
  executeWithStatus(request) {
    return execute(
      this.host,
      this.shopId,
      request,
      this.auth,
      this.additionalHeaders
    );
  }
}
class BasketMultiOperationsClient {
  constructor(client, latestBasket) {
    __publicField(this, "latestBasket");
    __publicField(this, "_client");
    __publicField(this, "errors");
    this.latestBasket = latestBasket;
    this.errors = [];
    this._client = client;
  }
  async deleteItem(itemKey, params = {}, debugVariantId) {
    try {
      const response = await this._client.basket.deleteItem(
        this.latestBasket.key,
        itemKey,
        params
      );
      this.updateBasket(response);
    } catch (e) {
      this.errors.push({
        operation: "delete",
        basketItemKey: itemKey,
        variantId: debugVariantId,
        message: `${e}`
      });
    }
  }
  async addItem(variantId, quantity = 1, params = {}) {
    try {
      const response = await this._client.basket.addItem(
        this.latestBasket.key,
        variantId,
        quantity,
        params
      );
      if (response.type === "failure") {
        this.errors.push({
          operation: "add",
          kind: response.kind,
          statusCode: response.statusCode,
          variantId
        });
      }
      this.updateBasket(response.basket);
    } catch (e) {
      this.errors.push({
        operation: "add",
        kind: "Unknown" /* Unknown */,
        statusCode: -1,
        variantId,
        message: `${e}`
      });
    }
  }
  async updateItem(itemKey, quantity, params = {}, debugVariantId) {
    try {
      const response = await this._client.basket.updateItem(
        this.latestBasket.key,
        itemKey,
        quantity,
        params
      );
      if (response.type === "failure") {
        this.errors.push({
          operation: "update",
          basketItemKey: itemKey,
          statusCode: response.statusCode,
          kind: response.kind,
          variantId: debugVariantId
        });
      }
      this.updateBasket(response.basket);
    } catch (e) {
      this.errors.push({
        operation: "update",
        basketItemKey: itemKey,
        statusCode: -1,
        kind: "Unknown" /* Unknown */,
        variantId: debugVariantId,
        message: `${e}`
      });
    }
  }
  updateBasket(basket) {
    if (basket && basket?.key === this.latestBasket.key) {
      this.latestBasket = basket;
    } else {
      throw Error(`Did not receive valid basket`);
    }
  }
}

var ProductStandardSorting = /* @__PURE__ */ ((ProductStandardSorting2) => {
  ProductStandardSorting2["Price"] = "price";
  ProductStandardSorting2["DateAdded"] = "new";
  ProductStandardSorting2["Reduction"] = "reduction";
  return ProductStandardSorting2;
})(ProductStandardSorting || {});
var CampaignStandardSorting = /* @__PURE__ */ ((CampaignStandardSorting2) => {
  CampaignStandardSorting2["Id"] = "id";
  CampaignStandardSorting2["Reduction"] = "reduction";
  CampaignStandardSorting2["StartAt"] = "start_at";
  CampaignStandardSorting2["EndAt"] = "end_at";
  return CampaignStandardSorting2;
})(CampaignStandardSorting || {});
var SortOrder = /* @__PURE__ */ ((SortOrder2) => {
  SortOrder2["Ascending"] = "asc";
  SortOrder2["Descending"] = "desc";
  return SortOrder2;
})(SortOrder || {});

const getFirstAttributeValue = (attributes, attributeName) => {
  const attribute = attributes && attributes[attributeName];
  if (!attribute || !attribute.values) {
    return;
  }
  if (attribute.multiSelect) {
    return attribute.values.length > 0 ? attribute.values[0] : void 0;
  }
  return attribute.values;
};
const getAttributeValues = (attributes, attributeName) => {
  const attribute = attributes && attributes[attributeName];
  if (!attribute || !attribute.values) {
    return [];
  }
  if (attribute.multiSelect) {
    return attribute.values;
  }
  return [attribute.values];
};

var PromotionEffectType = /* @__PURE__ */ ((PromotionEffectType2) => {
  PromotionEffectType2["AutomaticDiscount"] = "automatic_discount";
  PromotionEffectType2["BuyXGetY"] = "buy_x_get_y";
  return PromotionEffectType2;
})(PromotionEffectType || {});

export { ProductStandardSorting as APISortOption, SortOrder as APISortOrder, AddToBasketFailureKind, AddToWishlistFailureKind, CampaignStandardSorting as CampaignSortOption, CampaignStandardSorting, ExistingItemHandling, FetchError, FilterTypes, ProductStandardSorting, PromotionEffectType, SortOrder, StorefrontAPIClient, getAttributeValues, getFirstAttributeValue };
